import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'what_is_the_facs_form_of_production_operations_planning'

export const dataPointDefinition = {
  retracedId: 'what_is_the_facs_form_of_production_operations_planning',
  name: "What is the facility's form of production/ operations planning?",
  description: '',
  meta: {},
  fieldTypeId: 'SELECT_WITH_FOLLOW_UP',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Long term',
      key: 'LONG_TERM',
      slcpIndex: 1,
      slcpOptionName: 'fp-pi-17-opt',
    },
    {
      name: 'Monthly',
      key: 'MONTHLY',
      slcpIndex: 2,
      slcpOptionName: 'fp-pi-17-opt',
    },
    {
      name: 'Weekly',
      key: 'WEEKLY',
      slcpIndex: 3,
      slcpOptionName: 'fp-pi-17-opt',
    },
    {
      name: 'Other',
      key: 'OTHER',
      slcpIndex: 4,
      slcpOptionName: 'fp-pi-17-opt',
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'fp-pi-18',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'object',
        properties: {
          value: {
            type: 'string',
            enum: ['LONG_TERM', 'MONTHLY', 'WEEKLY', 'OTHER'],
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['value', 'followUp'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-pi-17',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 3860,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
